import EfBundlesCard from '@elem/ui/ef-bundles-card';
import EfTitle from '@elem/ui/ef-title';
import EFSGS from 'elem/ui-assets/icons/unregular/EFSGS';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useProductStore } from '../../../ProductProvider';
import { dataLocal } from './../configs';
import styles from './index.module.scss';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useLang } from '@/i18n';

export default function Bundles({ callbackCart }: any) {
    const { t } = useLang('rapid.bundles');
    const { locale = 'us' } = useRouter();
    const { data } = dataLocal[locale];
    const [gap, setGap] = useState(16);
    const [cards, setCards] = useState(data);
    const [init, setInit] = useState(false);
    const { pageStatus } = useProductStore();
    const IS_NA_SITES = ['us', 'ca'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const btnText1 = t('btn_1');
    const btnText2 = t('btn_2');
    // const btnText = pageStatus === 'statusB' ? btnText1 : btnText2;
    const btnText = btnText2;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1440 ? 24 : 16);
        }

        const tempData = JSON.parse(JSON.stringify(cards));
        const getAsynItem = async (productId: string, variantId: string, k: number, m?: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        const item = m >= 0 ? tempData[k].subs[m] : tempData[k];
                        item.discountPrice = res?.data?.price;
                        item.originalPrice = res?.data?.compareAtPrice ?? res?.data?.price;
                        item.inventoryQuantity = res?.data?.inventoryQuantity || 0;
                        const title = res.data?.skuTitle == 'Default Title' ? res.data?.productTitle : res.data?.skuTitle;
                        item.name = title || item.name;
                        item.img = res.data?.variantImg || res.data?.img || item.img;
                        if (m >= 0) {
                            item.parentVarientId = tempData[k].variantId;
                        }
                        // item.inventoryQuantity = 1;
                        // item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                        // if (res?.data?.img && !item?.img) {
                        //     item.img = res?.data?.img;
                        // }
                        // if (res?.data?.productTitle || res?.data?.skuTitle) {
                        //     item.name = res?.data?.productTitle || res?.data?.skuTitle;
                        // }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        const promises = [];
        tempData?.map((item: any, k: number) => {
            if (item?.variantId) {
                promises.push(getAsynItem(item?.productId, item?.variantId, k));
                if (item?.subs?.length > 0) {
                    item?.subs?.map((sub: any, m: number) => promises.push(getAsynItem(sub?.productId, sub?.variantId, k, m)));
                }
            }
        });
        Promise.all(promises)
            .then(() => {
                setCards(tempData);
                setInit(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div className={styles.bundles}>
            {init && <EfTitle hasAnimation={false}>{t('title')}</EfTitle>}
            {init && (
                <Swiper
                    className="swiper-cards"
                    modules={[Navigation]}
                    spaceBetween={gap}
                    loop={false}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    navigation={true}
                    autoplay={false}
                    // key={init}
                >
                    {cards?.map((card: any, k: number) => (
                        <SwiperSlide className="swiper-card" key={k}>
                            <EfBundlesCard {...card} hasAffirm={true} buyText={btnText} />
                            {k !== cards?.length - 1 && <EFSGS />}
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </div>
    );
}
